var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('img',{staticClass:"bt-banner img-fluid mx-auto d-block",attrs:{"src":_vm.BannerImg,"alt":"L'anse au Loup at Sunrise"}})])}
var staticRenderFns = []

export { render, staticRenderFns }